import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageBlocker } from "src/components/PageBlocker";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { SumbitResult } from "../ClassCardForm";
import { ClassCardMForm } from "../ClassCardMForm";
import {
  NewClassData,
  newClassPageStore as pageStore,
} from "./newClassPageStore";

export const NewClassPage: React.FC = observer(() => {
  const { id = "" } = useParams();
  const [search] = useSearchParams();
  React.useEffect(() => {
    pageStore.init(id, search.get("classId")).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.breadcrumbs ?? "Новый класс"}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: NewClassData }> = observer(() => {
  const navigate = useNavigate();
  const onSuccess = (result: SumbitResult) => {
    pageStore.form.setAsUnchanged();
    msgQueueStore.add({
      type: "success",
      message: `Создан класс ${result.name}`,
    });
    if (pageStore.data.status === "ready") {
      navigate(
        makeUrl(PageUrl.class, {
          id: result.id,
        }),
        { replace: true },
      );
    }
  };
  return (
    <>
      <PageBlocker changed={() => pageStore.form.isChanged} />
      <ClassCardMForm
        title="Новый класс"
        okText="Создать"
        form={pageStore.form}
        errorsStore={pageStore.errorsStore}
        save={() => pageStore.create()}
        onSuccess={onSuccess}
        onSecondarySpecsChanged={() => {
          msgQueueStore.add({
            type: "error",
            message: "Для новой записи нельзя добавлять вторичные спецификации",
          });
        }}
      />
    </>
  );
});
